import Helper from '@ember/component/helper';

export function lowercase([string]) {
  return string.toString().toLowerCase();
}

/*
  Basic Usage:

  ```handlebars
  {{lowercase string}}
  ```
*/
export default Helper.helper(lowercase);
